var _path, _path2, _ellipse, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMembersActive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 18,
    viewBox: "0 0 15 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.39159 7.04348C11.1205 7.04348 12.522 5.46674 12.522 3.52174C12.522 1.57674 11.1205 0 9.39159 0C8.47251 0 7.64593 0.44559 7.07324 1.15522C8.43936 1.82679 9.39134 3.33458 9.39134 5.08696C9.39134 5.77936 9.24271 6.43357 8.97864 7.01311C9.11377 7.03314 9.25161 7.04348 9.39159 7.04348Z",
    fill: "#ffffff"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.32617 10.1739H8.73922C10.3961 10.1739 11.7392 11.5171 11.7392 13.1739V16.4348H14.8696V11.3913C14.8696 10.2867 13.9742 9.3913 12.8696 9.3913H5.91311C5.26662 9.3913 4.69178 9.69803 4.32617 10.1739Z",
    fill: "#ffffff"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 5.47821,
    cy: 5.08696,
    rx: 3.13043,
    ry: 3.52174,
    fill: "#ffffff"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M0 12.9565C0 11.852 0.895431 10.9565 2 10.9565H8.95652C10.0611 10.9565 10.9565 11.852 10.9565 12.9565V18H0V12.9565Z",
    fill: "#ffffff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMembersActive);
export default __webpack_public_path__ + "static/media/membersActive.98d5aa25f3eb2ff08447f05dd13201b4.svg";
export { ForwardRef as ReactComponent };